<template>

	<div class="portlet box yellow-gold">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-line-chart" aria-hidden="true"></i>
				<span v-translate>Questões para indicadores</span>
			</div>

		</div>

		<div class="portlet-body">

			<div class="table-responsive">

				<table class="table table-striped table-bordered table-hover m-b-0">

					<thead>
						<tr>
							<th v-translate>Questão</th>
							<th v-translate>Muito Raramente</th>
							<th v-translate>Raramente</th>
							<th v-translate>Ás Vezes</th>
							<th v-translate>Frequentemente</th>
							<th v-translate>Muito Frequentemente</th>
						</tr>
					</thead>

					<tbody>

						<tr v-for="(question, index) in stdQuestions" class="form-group">
							<td>{{ question.evaluationSchoolQuestion.question.question }}</td>
							<td class="mt-radio-inline">

								<label class="mt-radio mt-radio-outline">
									<input type="radio" :name="question.evaluationSchoolQuestion.question.id" :data-index="index" @change="putAgendaQuestions" :value="1" :checked="question.answer === '1'">
									<span></span>
								</label>

							</td>

							<td class="mt-radio-inline">

								<label class="mt-radio mt-radio-outline">
									<input type="radio" :name="question.evaluationSchoolQuestion.question.id" :data-index="index" @change="putAgendaQuestions" :value="2" :checked="question.answer === '2'">
									<span></span>
								</label>

							</td>

							<td class="mt-radio-inline">

								<label class="mt-radio mt-radio-outline">
									<input type="radio" :name="question.evaluationSchoolQuestion.question.id" :data-index="index" @change="putAgendaQuestions" :value="3" :checked="question.answer === '3'">
									<span></span>
								</label>

							</td>

							<td class="mt-radio-inline">

								<label class="mt-radio mt-radio-outline">
									<input type="radio" :name="question.evaluationSchoolQuestion.question.id" :data-index="index" @change="putAgendaQuestions" :value="4" :checked="question.answer === '4'">
									<span></span>
								</label>

							</td>

							<td class="mt-radio-inline">

								<label class="mt-radio mt-radio-outline">
									<input type="radio" :name="question.evaluationSchoolQuestion.question.id" :data-index="index" @change="putAgendaQuestions" :value="5" :checked="question.answer === '5'">
									<span></span>
								</label>

							</td>

						</tr>

					</tbody>

				</table>

			</div>

		</div>

	</div>

</template>

<script>

	import StudentQuestion from './';
	export default StudentQuestion;

</script>



// WEBPACK FOOTER //
// StudentQuestion.vue?9532457e